/* eslint-disable no-unused-vars */
import PDialog from "../../../components/pos/PDialog";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import ProductPricingLevelView from "./ProductPricingLevelView";
import ProductBarcodeView from "./ProductBarcodeView";
import ProductPromotionView from "./ProductPromotionView";
import ProductStockBatchView from "./ProductStockBatchView";
import ProductIngredients from "./ProductIngredients";

function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
export default function ProductPricingMoreActions(props) {
  const { t } = useTranslation();
  const translate = t;
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitle] = useState("Pricing Actions");
  const [tabValue, setTabValue] = React.useState(0);
  const [tableMeta, setTableMeta] = useState(null);
  const [pricingLevelData, setPricingLevelData] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [barcodeData, setBarcodeData] = useState([]);
  const [promotionList, setPromotionList] = useState([]);
  const [ingredientsList, setIngredientsList] = useState([]);

  props.biRef.pricingMoreActions = {
    showProductPricingMoreActions: showProductPricingMoreActions,
  };

  function showProductPricingMoreActions(tableMeta) {
    if (tableMeta) {
      setTableMeta(tableMeta);
      setWindowTitle(
        "Pricing Action [ " +
          tableMeta.tableData[tableMeta.rowIndex][0].v.code +
          " ]"
      );
      setPricingLevelData([]);
      setIsAllSelected(false);
      setBarcodeData([]);
      setPromotionList([]);
      setOpenWindow(true);
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const content = (
    <div>
      <Tabs value={tabValue} onChange={handleTabChange}>
        <Tab label={translate("Product Barcode")} />
        <Tab label={translate("Pricing Level")} />
        <Tab label={translate("Product Promotions")} />

        {props.productType == "R" && <Tab label={translate("Ingredients")} />}
        {props.productType == "P" && <Tab label={translate("Raw Materials")} />}
      </Tabs>
      <TabPanel value={tabValue} index={0} style={{ padding: 0 }}>
        <Grid container style={{ height: 350 }}>
          <Grid item xs={12}>
            <ProductBarcodeView
              openWindow={openWindow}
              tableMeta={tableMeta}
              setPricingData={props.setPricingData}
              showMessage={props.showMessage}
              context={props.context}
              barcodeData={barcodeData}
              setBarcodeData={setBarcodeData}
              deptId={props.deptId}
            ></ProductBarcodeView>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={tabValue} index={1} style={{ padding: 0 }}>
        <Grid container style={{ height: 350 }}>
          <Grid item xs={12}>
            <ProductPricingLevelView
              openWindow={openWindow}
              tableMeta={tableMeta}
              setPricingData={props.setPricingData}
              showMessage={props.showMessage}
              context={props.context}
              pricingLevelData={pricingLevelData}
              setPricingLevelData={setPricingLevelData}
              isAllSelected={isAllSelected}
              setIsAllSelected={setIsAllSelected}
            ></ProductPricingLevelView>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel value={tabValue} index={2} style={{ padding: 0 }}>
        <Grid container style={{ height: 350 }}>
          <Grid item xs={12}>
            <ProductPromotionView
              openWindow={openWindow}
              tableMeta={tableMeta}
              setPricingData={props.setPricingData}
              showMessage={props.showMessage}
              context={props.context}
              promotionList={promotionList}
              setPromotionList={setPromotionList}
              onCloseWindow={onCloseWindow}
            ></ProductPromotionView>
          </Grid>
        </Grid>
      </TabPanel>
      {props.productType == "R" && (
        <TabPanel value={tabValue} index={3} style={{ padding: 0 }}>
          <Grid container style={{ height: 350 }}>
            <Grid item xs={12}>
              <ProductIngredients
                openWindow={openWindow}
                tableMeta={tableMeta}
                setPricingData={props.setPricingData}
                showMessage={props.showMessage}
                origObject={props.origObject}
                context={props.context}
                ingredientsList={ingredientsList}
                setIngredientsList={setIngredientsList}
              ></ProductIngredients>
            </Grid>
          </Grid>
        </TabPanel>
      )}
      {/*props.productType != "R" && (
        <TabPanel value={tabValue} index={3} style={{ padding: 0 }}>
          <Grid container style={{ height: 350 }}>
            <Grid item xs={12}>
              <ProductStockBatchView
                openWindow={openWindow}
                tableMeta={tableMeta}
                showMessage={props.showMessage}
                origObject={props.origObject}
                context={props.context}
              ></ProductStockBatchView>
            </Grid>
          </Grid>
        </TabPanel>
      )*/}
      {props.productType == "P" && (
        <TabPanel value={tabValue} index={3} style={{ padding: 0 }}>
          <Grid container style={{ height: 350 }}>
            <Grid item xs={12}>
              <ProductIngredients
                openWindow={openWindow}
                tableMeta={tableMeta}
                setPricingData={props.setPricingData}
                showMessage={props.showMessage}
                origObject={props.origObject}
                context={props.context}
                ingredientsList={ingredientsList}
                setIngredientsList={setIngredientsList}
              ></ProductIngredients>
            </Grid>
          </Grid>
        </TabPanel>
      )}
    </div>
  );

  function onCloseWindow() {
    setOpenWindow(false);
  }

  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          mode={"view"}
        ></PDialog>
      )}
    </div>
  );
}
